import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import Accountant from "../../components/Accountant"

const Accountants = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Accounts | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <Accountant />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Accountants
